import * as React from 'react';
import { Box } from '../layoutPrimitives';
import * as darkStyles from '../styles/dark.module.css';
import * as lightStyles from '../styles/light.module.css';

export const ThemeContext = React.createContext();

export function useThemeContext() {
  const context = React.useContext(ThemeContext);

  if (context === undefined)
    throw new Error('useThemeContext must be used within ThemeProvider');

  return context;
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = React.useState('light');
  const [initialLoad, setInitialLoad] = React.useState(false);
  const themeStyles = theme === 'light' ? lightStyles : darkStyles;

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  React.useEffect(() => {
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme) setTheme(savedTheme);

    setInitialLoad(true);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {initialLoad && <Box className={themeStyles.container}>{children}</Box>}
    </ThemeContext.Provider>
  );
};
